module.exports = __webpack_public_path__ + "static/media/partner-7.a9db9d0d.webp";